import { render, staticRenderFns } from "./GateWayView.vue?vue&type=template&id=55379406&scoped=true"
import script from "./GateWayView.vue?vue&type=script&lang=js"
export * from "./GateWayView.vue?vue&type=script&lang=js"
import style0 from "./GateWayView.vue?vue&type=style&index=0&id=55379406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55379406",
  null
  
)

export default component.exports